import type { ReactNode } from 'react';

import { ru } from '@/i18n/ru';
import { cn } from '@/lib/cn';

export function EmptyState({
  title,
  description,
  action,
  className,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 px-6 py-16 text-center',
        className,
      )}
    >
      <p className="text-sm text-text">{title}</p>
      {description ? <p className="text-xs text-text-muted max-w-sm">{description}</p> : null}
      {action}
    </div>
  );
}

export function ErrorState({
  title = ru.somethingWrong,
  message,
  onRetry,
  className,
}: {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 px-6 py-16 text-center',
        className,
      )}
    >
      <p className="text-sm text-danger">{title}</p>
      {message ? <p className="text-xs text-text-muted max-w-sm">{message}</p> : null}
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="mt-2 text-xs text-accent hover:underline focus-visible:outline focus-visible:outline-1 focus-visible:outline-accent"
        >
          {ru.tryAgain}
        </button>
      ) : null}
    </div>
  );
}
